import { openSplitExpense } from './splitExpense.mjs';
import t from 'virtual:i18n';

/**
 * Renders the "Add More Receipts" button.
 * @param {HTMLElement} parentEl - The element to append the button container to.
 * @param {Group} group - The group object.
 */
export function renderAddReceiptsButton(parentEl, group) {
    // Show "No expenses yet" text if there are no expenses
    if (!group.expenses || group.expenses.length === 0) {
        const noReceiptsText = document.createElement('div');
        noReceiptsText.innerText = t.noExpensesYet;
        Object.assign(noReceiptsText.style, {
            textAlign: 'center',
            color: '#888',
            fontSize: '16px',
            marginBottom: '16px',
            fontStyle: 'italic'
        });
        parentEl.appendChild(noReceiptsText);
    }

    // Add More Receipts Button
    const addReceiptsContainer = document.createElement('div');
    Object.assign(addReceiptsContainer.style, {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '24px'
    });

    const addBtn = document.createElement('button');
    addBtn.innerText = `+ ${t.addMoreReceipts}`;
    Object.assign(addBtn.style, {
        padding: '12px 24px',
        borderRadius: '24px',
        backgroundColor: '#E8DEF8', // Tonal button (Light primary container)
        color: '#1D192B', // Dark on-surface text
        border: 'none',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '14px',
        boxShadow: 'none',
        transition: 'transform 0.2s, background-color 0.2s'
    });

    addBtn.onmouseover = () => addBtn.style.backgroundColor = '#D8CEF0';
    addBtn.onmouseout = () => addBtn.style.backgroundColor = '#E8DEF8';
    addBtn.onmousedown = () => addBtn.style.transform = 'scale(0.98)';
    addBtn.onmouseup = () => addBtn.style.transform = 'scale(1)';

    addBtn.onclick = () => {
        openSplitExpense(group);
    };
    addReceiptsContainer.appendChild(addBtn);
    parentEl.appendChild(addReceiptsContainer);
}
